const POLL_INTERVAL = 5000;
export default class FileConverterClient {
    static service = 'showell.file-converter';
    autoConversionFormatPromise;
    serviceClient;
    constructor(serviceClient) {
        this.serviceClient = serviceClient;
    }
    reset() {
        this.autoConversionFormatPromise = undefined;
    }
    /**
     * Pre-fetch conversion settings
     */
    async preFetch() {
        await this.getAutoConversionFormats();
    }
    async shouldConvert(filename) {
        const format = await this.getAutoConversionFormat(filename);
        return format !== undefined;
    }
    async getAutoConversionFormat(filename) {
        const formats = await this.getAutoConversionFormats();
        let normalizedFilename = filename.toLowerCase();
        return Object.keys(formats).find(format => normalizedFilename.endsWith('.' + format) &&
            normalizedFilename !== '.' + format);
    }
    async statDir(query) {
        return await this.serviceClient.exec(`${FileConverterClient.service}/stat-dir`, {
            query,
        });
    }
    async pollDir(query, interval = POLL_INTERVAL) {
        let timeout = null;
        let reject = (e) => { };
        const cancel = () => {
            timeout && clearTimeout(timeout);
            timeout = null;
            reject(new Error('Cancelled'));
        };
        const allConversions = await this.statDir(query);
        const incompleteConversions = allConversions.filter(isProcessing);
        let next;
        if (incompleteConversions.length) {
            next = new Promise((_resolve, _reject) => {
                reject = _reject;
                timeout = setTimeout(async () => {
                    try {
                        const poll = await this.pollDir(query, interval);
                        _resolve(poll);
                    }
                    catch (e) {
                        _reject(e);
                    }
                }, interval);
            });
        }
        return {
            conversions: allConversions,
            next,
            cancel,
        };
    }
    async getAutoConversionFormats() {
        if (this.autoConversionFormatPromise) {
            return this.autoConversionFormatPromise;
        }
        let resolve = (formats) => { };
        let reject = (e) => { };
        const promise = new Promise((_res, _rej) => {
            resolve = _res;
            reject = _rej;
        });
        this.autoConversionFormatPromise = promise;
        try {
            const formats = await this.serviceClient.exec(`${FileConverterClient.service}/get-auto-formats`, {});
            resolve(formats);
        }
        catch (e) {
            this.autoConversionFormatPromise = undefined;
            reject(e);
        }
        return promise;
    }
}
export const isProcessing = (stat) => stat.status !== 'ready' && stat.status !== 'error';
export const isFailed = (stat) => stat.status === 'error';
export const isReady = (stat) => stat.status === 'ready';
